import { ResortAllInclusiveRule } from '../../models/presentation.model';

export class AllInclusiveFeeDetails{
    public rule:ResortAllInclusiveRule;
    public multiplier: number;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/pricing-information/all-inclusive-fee-details.model.ts